import {
  BUY_X_GET_Y,
  FREE_ITEM,
  DISCOUNT_PER_ITEM,
  MOKA_ORDER_PRICE_CUTS,
  ADVANCE_PROMO,
} from '../constants/library';

export function isBuyXGetY(promoType?: string) {
  return promoType?.toUpperCase() === BUY_X_GET_Y;
}

export function isFreeItem(promoType?: string) {
  return promoType?.toUpperCase() === FREE_ITEM;
}

export function isDiscountPerItem(promoType?: string) {
  return promoType?.toUpperCase() === DISCOUNT_PER_ITEM;
}

export function isGostorePriceCuts(promoType?: string) {
  return promoType === MOKA_ORDER_PRICE_CUTS;
}

export function isAdvancePromo(promoType?: string) {
  return promoType?.toUpperCase() === ADVANCE_PROMO;
}
